import { gql } from '@apollo/client';
import { CORE_EXPERT_FIELDS } from './fragments';

export const listExperts = gql`
  ${CORE_EXPERT_FIELDS}
  query ListExperts($pagination: PaginationInput) {
    listExperts(pagination: $pagination) {
      ...CoreExpertFields
    }
  }
`;

export const listSocialMediaTypes = gql`
  query ListSocialMediaTypes {
    listSocialMediaTypes {
      id
      name
      icon
    }
  }
`;
